import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Login, { LoginMode } from "../components/login/login";
var PasswordForgotPage = function PasswordForgotPage() {
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Passwort vergessen"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "border-t-8 border-solid border-makroOrange"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, "Passwort vergessen"), /*#__PURE__*/ React.createElement("div", {
        className: "pb-8"
    }, /*#__PURE__*/ React.createElement(Login, {
        initialMode: LoginMode.FORGOT_PASSWORD
    })))));
};
export default PasswordForgotPage;
